// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

export function InformationBox(): Node {

  return (
    <Root>
      <DisplayInformation/>
    </Root>
  );
}

function DisplayInformation(): Node {
  return (
    <ChildrenWrapper>
      <Title>Importante:</Title>
      <p>A transação só será efetivada após a autenticação na instituição de débito na condição da existência de fundos na conta selecionada.</p>
    </ChildrenWrapper>
  );
}

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 80%;
  margin: auto;
`;

const ChildrenWrapper = styled.div`
  background: #fdf9e7;
  border: 1px solid #f7e390;
  border-radius: 3px;
  font-family: ${theme.fontFamily.sansSerif};
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: #555555;
  margin: 5px auto 5px;
  padding: 16px;
`;

const Title = styled.h1`
  font-weight: 700;
`;
